<template>
  <div>
    <input type="hidden" :name="name" :value="hiddenValue | json" />
    <div class="list-from-to-main">
      <a @click="onAddNew" class="dashicons dashicons-plus-alt"
        >{{ $t("components.invest.listFromTo.addNew") }}</a
      >
      <div class="list-form-to-self" v-if="hiddenValue">
        <div v-for="(hValue, index) in hiddenValue" :key="index">
          <div>
            <!-- <span>от</span> -->
            <v-text-field
              v-model="hValue.from"
              :label="$t('components.invest.listFromTo.from')"
              type="number"
              :disabled="hiddenValue.length > 1 ? true : false"
              @input="afterChangeGrid"
            ></v-text-field>
            <!-- <span>до</span> -->
            <v-text-field
              v-model="hValue.to"
              :label="$t('components.invest.listFromTo.to')"
              type="number"
              :disabled="index != hiddenValue.length - 1"
              @input="afterChangeGrid"
            ></v-text-field>
            <v-text-field
              v-model="hValue.percent_each"
              :label="$t('components.invest.listFromTo.percent_each')"
              type="number"
              placeholder="0"
              @input="afterChangeGrid"
            ></v-text-field>
            <v-text-field
              v-model="hValue.percent"
              :label="$t('components.invest.listFromTo.percent')"
              type="number"
              placeholder="0"
              @input="afterChangeGrid"
            ></v-text-field>
            <a
              v-if="index == hiddenValue.length - 1"
              @click="onRemoveLastItem()"
              class="dashicons dashicons-trash"
              >{{$t('components.invest.listFromTo.delete')}}</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListFromTo",
  data: () => ({
    hiddenValue: [
      {
        from: 0,
        to: 12,
        percent_each: 12,
        percent: 12.5,
      },
      {
        from: 13,
        to: 24,
        percent_each: 14,
        percent: 14.5,
      },
      {
        from: 25,
        to: 36,
        percent_each: 13,
        percent: 13.5,
      },
    ],
  }),
  props: {
    name: {
      type: String,
      default: "",
    },
    existValue: {
      type: String,
      default: "",
    },
  },
  computed: {
    
  },

  methods: {
    isAddNew() {
      if (!this.hiddenValue) this.hiddenValue = [];
      if (this.hiddenValue.length > 0) {
        if (this.hiddenValue[this.hiddenValue.length - 1].to == null)
          return false;
      }
      return true;
    },

    __beforeAdd(from, to) {
      if (!this.hiddenValue) this.hiddenValue = [];
      if (this.hiddenValue.length > 0) {
        if (this.hiddenValue[this.hiddenValue.length - 1].to >= to)
          return false;
        if (from && to < from) return false;
        if (from && from < this.hiddenValue[this.hiddenValue.length - 1].to)
          return false;
      }
      return true;
    },
    __AddFromTo(from, to, value) {
      if (!this.hiddenValue) this.hiddenValue = [];

      if (from && to && !this.__beforeAdd(from, to)) return;

      this.hiddenValue.push({
        from: from,
        to: to,
        value: value,
      });
    },
    onAddNew() {
      let from = 0;
      if (this.hiddenValue && this.hiddenValue.length > 0) {
        from = this.hiddenValue[this.hiddenValue.length - 1].to;
      }
      if (this.isAddNew()) this.__AddFromTo(from, null, null);
    },
    onRemoveLastItem() {
      if (!this.hiddenValue) this.hiddenValue = [];
      if (this.hiddenValue.length > 0) {
        this.hiddenValue.splice(this.hiddenValue.length - 1, 1);
      }
    },

    afterChangeGrid() {
      this.$emit("change", this.hiddenValue);
    }
  },
  mounted() {
    if (this.existValue && this.existValue.length > 0) {
      try {
        this.hiddenValue = JSON.parse(this.existValue);
        if (typeof this.hiddenValue != "object") this.hiddenValue = null;
      } catch (e) {
        this.hiddenValue = null;
      }
    }

    this.afterChangeGrid();
  },

  watch: {
    hiddenValue(val) {
      this.$emit("change", val);
    },
  },

  filters: {
    json: function (value) {
      if (!value) return "";
      return JSON.stringify(value);
    },
  },
};
</script>
<style lang="scss">
.list-from-to-main a {
  width: auto !important;
  font-size: 17px;
}
.list-from-to-main a.dashicons-plus-alt {
  color: #008000;
  cursor: pointer;
}
.list-from-to-main a.dashicons-trash {
  color: #f37373;
  cursor: pointer;
}
.list-form-to-self {
  margin-top: 10px;
}
.list-form-to-self > div {
  display: flex;
  align-items: center;
}

.list-form-to-self > div:not(:last-child) {
  margin-bottom: 5px;
}

.list-form-to-self > div > a {
  display: block;
  margin-left: 10px;
}

.list-form-to-self > div > div {
  display: flex;
  > * {
    padding: 5px;
  }
}
</style>
